(() => {
  const ROOT_SELECTOR = "[data-looom-contact]";

  const initialize = (root) => {
    if (root.dataset.looomContactInitialized === "true") return;

    const textarea = root.querySelector("[data-looom-contact-textarea]");

    root.dataset.looomContactInitialized = "true";

    if (textarea) {
      const resizeTextarea = () => {
        if (textarea.value === "") {
          textarea.style.height = "";
          textarea.style.overflowY = "auto";
          return;
        }

        const styles = window.getComputedStyle(textarea);
        const lineHeight = Number.parseFloat(styles.lineHeight);
        const padding =
          Number.parseFloat(styles.paddingTop) + Number.parseFloat(styles.paddingBottom);
        const borders =
          Number.parseFloat(styles.borderTopWidth) + Number.parseFloat(styles.borderBottomWidth);
        const maximumHeight = lineHeight * 4 + padding + borders;

        textarea.style.height = "0px";

        const contentHeight = textarea.scrollHeight + borders;
        const nextHeight = Math.min(contentHeight, maximumHeight);

        textarea.style.height = `${nextHeight}px`;
        textarea.style.overflowY = "auto";
      };

      textarea.addEventListener("input", resizeTextarea);
      resizeTextarea();
    }
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initialize(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  if (document.documentElement.dataset.looomContactEditorListener !== "true") {
    document.documentElement.dataset.looomContactEditorListener = "true";
    document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
  }
})();
